export const phoneClear = (phone: string) =>
  `${phone.toString().replace(/[^\d]/g, '')}`
